// extracted by mini-css-extract-plugin
module.exports = {"header":"R_nSgaTI012Gsdm8Bf40"};